import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/primeng';

@Component({
    selector: 'member-recurring-charges',
    templateUrl: './member.recurring.charges.component.html',
    styleUrls: ['./member.recurring.charges.component.css']
})
export class MemberRecurringChargesComponent implements OnInit {

    IsBusy: boolean = false;

    product: SelectItem[];

    selectedProduct: string;

    constructor() {
        this.product = [];
        this.product.push({ label: 'Select Product', value: null });
        this.product.push({ label: 'Vip3D monthly', value: { id: 1, name: 'VIPm' } });
        this.product.push({ label: 'Vip3D yearly', value: { id: 2, name: 'VIPy' } });
        this.product.push({ label: 'VizTerra monthly', value: { id: 3, name: 'VTm' } });
        this.product.push({ label: 'VizTerra yearly', value: { id: 4, name: 'VTy' } });
        this.product.push({ label: 'Pool Studio monthly', value: { id: 5, name: 'PSm' } });
        this.product.push({ label: 'Pool Studio yearly', value: { id: 6, name: 'PSy' } });
    }

    ngOnInit() {
    }

}
